<template>
	<div class="goods-info-body">
		<div class="goods-info-box">
			<div class="basis-info-body">
				<p>
					<span style="display: flex;align-items: center;">
						商品属性
						<el-tooltip effect="dark" placement="right">
							<div slot="content">
								【1】启用、公开、可见商品小程序和卖家后台都可以下单<br/>
								【2】启用、公开、不可见商品小程序和卖家后台都不可以下单<br/>
								【3】启用、私密未关联客户、可见商品小程序和卖家后台都不可以下单（组合品中商品明细为私密未关联客户则不允许下单）<br/>
								【4】启用、私密已关联客户、可见商品小程序和卖家后台都可以下单，组合品和附属品可以下单<br/>
								【5】停用商品无论何种状态都不可以下单<br/>
								【6】启用、私密未关联客户、不可见商品小程序和卖家后台都不可以下单（组合品中商品明细为私密未关联客户则不允许下单）<br/>
								【7】启用、私密已关联客户、 不可见商品小程序不可以下单，卖家后台可以下单，组合品和附属品可以下单<br/>
							</div>
							<img src="~/images/icon/tooltip-icon.png" class="spec-title">
						</el-tooltip>
					</span>
				</p>
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="form-box">
					<div class="info-box">
						<el-form-item label="商品名称：" prop="goodsName">
							<el-input :disabled="editDisable" :maxlength='50' v-model="ruleForm.goodsName" class="short-input" size="small" placeholder="请输入商品名称"></el-input>
						</el-form-item>
						<el-form-item label="商品编号：">
							<el-input :disabled='(matchbillcenterflag && !producttype) || editDisable' v-model="ruleForm.code" class="short-input" size="small" @input="codeInput" :maxlength="15" placeholder="请输入商品编号"></el-input>
						</el-form-item>
						<el-form-item label="店铺分类：" prop='category' ref="category" class="category-box">
							<div class="category-select-wrap">
								<el-select :disabled="editDisable" v-model="ruleForm.bigCategory" class="category-select" size="small" placeholder="请选择店铺级大类" @change="bigCategoryChange('ruleForm')">
									<template v-for="(item) in bigCategoryList">
										<el-option
											:value="item.bc_id"
											:label="item.bc_name"
											:key="item.bc_id"
											v-if="!item.disabledflag"/>
									</template>
								</el-select>
								<el-select :disabled="editDisable" v-model="ruleForm.smallCategory" class="category-select" v-if="bigcategoryview === 1" size="small" placeholder="请选择店铺级小类" @change="smallCategoryChange('ruleForm')">
									<template v-for="(item) in smallCategoryList">
										<el-option
											:key="item.id"
											:label="item.name"
											:value="item.id"
											v-if="!item.disabledflag">
										</el-option>
									</template>
								</el-select>
								<el-select ref="thirdCategorySelect" :disabled="editDisable" v-model="ruleForm.thirdCategory" class="category-select" v-if="thirdCategoryEnabled" size="small" placeholder="请选择三级小类" clearable @visible-change="thirdCategoryVisibleChange">
									<template v-for="(item) in thirdCategoryList">
										<el-option
											:key="item.id"
											:label="item.name"
											:value="item.id"
											v-if="!item.disabledflag">
										</el-option>
									</template>
								</el-select>
								<el-button type='text' size="mini" @click="goClass">去设置店铺分类模板</el-button>
							</div>
						</el-form-item>
					</div>
					<div class="info-box">
						<el-form-item v-if='matchbillcenterflag' label="商品名称：" class='state-box'>
							<div>{{productInfo.matchname}}</div>
						</el-form-item>
						<el-form-item v-if='!matchbillcenterflag || (matchbillcenterflag && producttype)'  label="启用状态：" prop="startRadio" class="state-box">
							<el-radio :disabled="editDisable" v-model="ruleForm.startRadio" :label="false">启用</el-radio>
							<el-radio :disabled="editDisable" v-model="ruleForm.startRadio" :label="true">禁用</el-radio>
						</el-form-item>
						<el-form-item v-else label="启用状态：">
							<div style="width: 80px;">{{ruleForm.startRadio ? '禁用' : '启用'}}</div>
						</el-form-item>
						<el-form-item label="私密状态：" prop="privateRadio" class="state-box">
							<el-radio :disabled="editDisable" v-model="ruleForm.privateRadio" :label="false">公开</el-radio>
							<el-radio :disabled="editDisable" v-model="ruleForm.privateRadio" :label="true">私密</el-radio>
						</el-form-item>
						<el-form-item label="可见状态：" prop="visibleflag" class="state-box">
							<el-radio :disabled="editDisable" v-model="ruleForm.visibleflag" :label="true">可见</el-radio>
							<el-radio :disabled="editDisable" v-model="ruleForm.visibleflag" :label="false">不可见</el-radio>
						</el-form-item>
						<el-form-item label="店内显示顺序：">
							<div style="width: 400px;">
								<el-input :disabled="editDisable" v-model="ruleForm.shopSeqnum" class="short-input" size="small" @input="orderInput"></el-input>
								<span style="color:#606266">（数值越大，越靠前显示）</span>
							</div>

						</el-form-item>
					</div>
					<div class="info-box" style="align-items:start">
						<el-form-item label="促销标签：">
							<el-select v-model="ruleForm.mark" class="accept-input" style="min-width:80px" size='small'>
								<el-option value="-1" label="无"></el-option>
								<el-option value="0" label="招牌"></el-option>
								<el-option value="1" label="热销"></el-option>
								<el-option value="2" label="新品"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="参与整单运费计算：" prop="startRadio" class="freight-box">
							<el-radio :disabled="editDisable || producttype" v-model="ruleForm.calcNormalFreightFlag" :label="1">参与</el-radio>
							<el-radio :disabled="editDisable || producttype" v-model="ruleForm.calcNormalFreightFlag" :label="0">不参与</el-radio>
						</el-form-item>
						<el-form-item label="未登录时是否显示：" prop="startRadio" class="freight-box">
							<el-radio :disabled="editDisable" v-model="ruleForm.showflag" :label="1">显示</el-radio>
							<el-radio :disabled="editDisable" v-model="ruleForm.showflag" :label="0">不显示</el-radio>
						</el-form-item>
						<!-- <el-form-item label="商品介绍：" style="display:block" class="textarea-box">
							<el-input :disabled="editDisable" class='long-input' type="textarea" v-model="ruleForm.goodsExplain" :rows='5' :maxlength='300'></el-input>
						</el-form-item> -->
					</div>
				</el-form>
			</div>
			<div v-show="producttype">
				<div class="fx-title">
					<span>商品价格</span>
				</div>
				<div class="unit-box" style="display: flex;align-items: center;">
					<div class="title1">
						组合品价格:
					</div>
					<el-radio :disabled="editDisable" v-model="packageProductPriceType" :label="0">取明细价格之和</el-radio>
					<el-radio :disabled="editDisable" v-model="packageProductPriceType" :label="1">自定义组合价格</el-radio>
					<el-input style="width:100px;margin-right:10px" size="mini" :disabled="editDisable" @blur="priceBlur" v-model="customizePackageProductPrice"></el-input>元
				</div>
			</div>
			<div v-if="shopList.length > 1">
				<div class="fx-title">
					<span>适用门店</span>
				</div>
				<div class="unit-box" style="display: flex;align-items: center;">
					<div class="title1">
						适用门店：
					</div>
					<el-radio :disabled="editDisable || (matchbillcenterflag && !producttype)" v-model="relAllShopFlag" :label="1">全部门店</el-radio>
					<el-radio :disabled="editDisable || (matchbillcenterflag && !producttype)" v-model="relAllShopFlag" :label="0">自定义门店</el-radio>
					<span  v-if="relAllShopFlag === 0 && (!matchbillcenterflag || (matchbillcenterflag && producttype)) && !editDisable" @click="bindShopClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择门店
					</span>
				</div>
				<div class="unit-box" v-if="relAllShopFlag === 0">
					<div class="title1">
						已选：
					</div>
					<span>{{shopText}}</span>
				</div>
			</div>
			<div v-if="!matchbillcenterflag && !producttype" class="basis-info-body">
				<p>
					<span>单位</span>
				</p>
				<div class="unit-box">
					<el-checkbox :disabled="editDisable" v-model="useUnitFlag">启用辅助单位</el-checkbox>
				</div>
				<div v-if="useUnitFlag" >
					<div style="display: flex;flex-direction: row;align-items: center;width: 650px;">
						<div style="min-width: 80px;text-align: right;">基础单位：</div>
						<el-cascader
							ref="cascader1"
							v-if="AuthorityList['02_0003_0003_00'] && AuthorityList['02_0003_0001_00']"
							v-model="baseUnitId"
							size="mini"
							:disabled="useFlag || editDisable"
							style="width:100%"
							:props="defaultParams"
							:options="baseList"
							:clearable="true"
							@change="baseUnitIdChange"
							@visible-change="v => visibleChange(v, 'cascader1')"
							/>
						<el-cascader
							ref="cascader2"
							v-if="!AuthorityList['02_0003_0003_00'] && AuthorityList['02_0003_0001_00']"
							v-model="baseUnitId"
							size="mini"
							:disabled="useFlag || editDisable"
							style="width:100%"
							:props="defaultParams"
							:options="baseList"
							:clearable="true"
							@change="baseUnitIdChange"
							@visible-change="v => visibleChange1(v, 'cascader2')"
							/>
						<el-cascader
							ref="cascader3"
							v-if="AuthorityList['02_0003_0003_00'] && !AuthorityList['02_0003_0001_00']"
							v-model="baseUnitId"
							size="mini"
							:disabled="useFlag || editDisable"
							style="width:100%"
							:props="defaultParams"
							:options="baseList"
							:clearable="true"
							@change="baseUnitIdChange"
							@visible-change="v => visibleChange2(v, 'cascader3')"
							/>
						<el-cascader
							ref="cascader4"
							v-if="!AuthorityList['02_0003_0003_00'] && !AuthorityList['02_0003_0001_00']"
							v-model="baseUnitId"
							size="mini"
							:disabled="useFlag || editDisable"
							style="width:100%"
							:props="defaultParams"
							:options="baseList"
							:clearable="true"
							@change="baseUnitIdChange"
							@visible-change="v => visibleChange3(v, 'cascader4')"
							/>
							<div v-if="useFlag" style="min-width: 150px;text-align: right;">基础档案已使用，不能修改</div>
							<div v-else style="min-width: 150px;text-align: right;"></div>
					</div>

					<div style="width :500px;display: flex;flex-direction: row;margin-top: 10px;margin-bottom: 10px;align-items: center;">
						<div style="min-width: 80px;text-align: right;">辅助单位：</div>
							<el-cascader
								:disabled="baseUnitId === '' || editDisable"
								v-if="AuthorityList['02_0003_0003_00'] && AuthorityList['02_0003_0001_00']"
								ref="cascader5"
								v-model="assistUnitId"
								size="mini"
								style="width:100%"
								:props="defaultParams"
								:options="assistList"
								:clearable="true"
								@change="assistUnitIdChange"
								@visible-change="v => visibleChange(v, 'cascader5')"
								/>
							<el-cascader
								:disabled="baseUnitId === '' || editDisable"
								v-if="!AuthorityList['02_0003_0003_00'] && AuthorityList['02_0003_0001_00']"
								ref="cascader6"
								v-model="assistUnitId"
								size="mini"
								style="width:100%"
								:props="defaultParams"
								:options="assistList"
								:clearable="true"
								@change="assistUnitIdChange"
								@visible-change="v => visibleChange1(v, 'cascader6')"
								/>
							<el-cascader
								:disabled="baseUnitId === '' || editDisable"
								v-if="AuthorityList['02_0003_0003_00'] && !AuthorityList['02_0003_0001_00']"
								ref="cascader7"
								v-model="assistUnitId"
								size="mini"
								style="width:100%"
								:props="defaultParams"
								:options="assistList"
								:clearable="true"
								@change="assistUnitIdChange"
								@visible-change="v => visibleChange2(v, 'cascader7')"
								/>
							<el-cascader
								:disabled="baseUnitId === '' || editDisable"
								v-if="!AuthorityList['02_0003_0003_00'] && !AuthorityList['02_0003_0001_00']"
								ref="cascader8"
								v-model="assistUnitId"
								size="mini"
								style="width:100%"
								:props="defaultParams"
								:options="assistList"
								:clearable="true"
								@change="assistUnitIdChange"
								@visible-change="v => visibleChange3(v, 'cascader8')"
								/>
							<span style="margin-left: 5px;margin-right: 5px;">=</span>
							<el-input @input='ratioInput' :disabled="baseUnitId === '' || editDisable" size="mini" v-model="ratio">
								<span slot="append">{{baseUnit}}</span>
							</el-input>
						</div>
					</div>

			</div>
			<div class="show-img-body">
				<ShowImg :imgInfo='imgInfo' :videoInfo='videoInfo' :editDisable='editDisable' ref="showImgRef" v-if="reloadComponent"/>
				<AttrInfo ref="attrInfo" :productDetails="productDetails" :producttype='producttype' :proTransportMode='transportMode' :editDisable='editDisable'/>
			</div>
			<div class="goods-status-box" v-show="!producttype">
				<setSpec ref="setSpec" :productName='ruleForm.goodsName' :code='ruleForm.code' :relAllShopFlag='relAllShopFlag' :chooseShop='chooseShop' :actualtimeinventoryflag='actualtimeinventoryflag' :editDisable='editDisable' :matchbillcenterflag='matchbillcenterflag' :costshowflag='costshowflag' :SKUType="SKUType" :SKUValue="SKUValue" :productId="productId" @addSku="addSku" @refreshData="refreshData" @saveNew="saveInfo"/>
			</div>
			<div class="basis-info-body" v-show="producttype">
				<p>
					<span>关联商品</span>
				</p>
				<div class="package-info">
					<div class="left">
						<div class="info-box">
							规格：
							<el-input size='mini' style="width:200px" v-model="productAttrvalueName" placeholder="请输入规格值"></el-input>
						</div>
						<div class="info-box" style="margin-left: 30px;" v-if="skuCode">
							SKU编码：{{skuCode}}
						</div>
						<div class="info-box">
							<el-button type="primary" size='small' class="fx-big-btn" plain icon='el-icon-plus' @click="addGoods">添加商品</el-button>
							<span style="color:red;margin-left:20px;">注：请务必使 组合商品，组合内SKU 都属于同一个店铺/客户，否则组合商品加购会失败！</span>
						</div>
					</div>
					<div class="right">
						<span>是否部分加购：</span>
						<el-tooltip class="item" effect="dark" content="如组合内SKU 失效或者库存不足时，可继续加购组合内其它SKU" placement="top-start">
							<el-switch
								v-model="packageflag"
								active-color="#13ce66"
								inactive-color="#dcdfe6">
							</el-switch>
						</el-tooltip>
					</div>
				</div>
					<div style="width:100%;min-height:200px;margin-top:10px">
				<el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				:data="packageProducts"
				min-height="200"
				border>
					<el-table-column
						prop="productcode"
						label="SPU编号"
						align="center"
						min-width="100">
					</el-table-column>
					<el-table-column
						prop="code"
						label="SKU编号"
						align="center"
						min-width="100">
					</el-table-column>
					<el-table-column
						prop="productname"
						label="商品名称"
						align="center"
						min-width="120">
					</el-table-column>
					<el-table-column
						prop="spec"
						label="规格名称"
						align="center"
						min-width="100">
					</el-table-column>
					<el-table-column
						prop="price"
						label="售价"
						align="center"
						min-width="160">
						<template slot="header">
							<div class="title-box">售价
								<el-tooltip class="item" effect="dark" content="售价为基础单位对应的售价" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
						<template slot-scope="scope">
							{{scope.row.price === -1 ? '' : scope.row.price}}
						</template>
					</el-table-column>
					<el-table-column
						prop="costprice"
						label="成本价"
						v-if="costshowflag === 1"
						key="costprice"
						align="center"
						min-width="160">
						<template slot="header">
							<div class="title-box">成本价
								<el-tooltip class="item" effect="dark" content="成本价为基础单位对应的成本价" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="productcount"
						label="组合内数量"
						align="center"
						min-width="160">
						<template slot="header">
							<div class="title-box">组合内数量
								<el-tooltip class="item" effect="dark" content="当商品存在辅助单位时，此处为辅助单位的数量" placement="top-start">
									<img src="~/images/icon/tooltip-icon.png" class="spec-title">
								</el-tooltip>
							</div>
						</template>
						<template slot-scope='scope'>
							<el-input style="width: 80%;" @input='checkNum(scope.row)' @blur="blurNum(scope.row)" v-model="scope.row.productcount" size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column
						key="typeCategory"
						v-if="bigcategoryview === 1"
						prop="typeCategory"
						label="商品类别"
						align="center"
						min-width="160">
					</el-table-column>
					<el-table-column
						key="bbcname"
						v-if="bigcategoryview !== 1"
						prop="bbcname"
						label="商品类别"
						align="center"
						min-width="160">
					</el-table-column>
					<el-table-column label="操作" min-width="100" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click='delClick(scope.row.attrplanid)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			</div>
			<div>
				<div class="fx-title">
					<span>商品介绍</span>
				</div>
				<goodsIntro ref="goodsIntro" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'/>
			</div>
		</div>
		<div class="btn-box">
			<el-button class="btn" size='small' plain type="primary" @click="cancel">返回</el-button>
			<el-button class="btn" size='small' type="primary" v-if="!matchbillcenterflag && isAdd && !editDisable && !producttype" @click="saveContinue">保存并继续</el-button>
			<el-button class="btn" size='small' type="primary" v-if="!editDisable && !producttype" @click="saveInfo">保存</el-button>
			<el-button class="btn" size='small' type="primary" v-if="!editDisable && producttype" @click="saveParkageInfo">保存</el-button>
			<el-button class="btn" size='small' type="primary" v-if="!editDisable && productId !== '' && (!matchbillcenterflag || (matchbillcenterflag && producttype))" @click='copyClick'>复制商品</el-button>
		</div>

		<el-dialog
			top='100px'
			title="选择适用门店"
			class="unit-dialog"
			:visible.sync="shopDialog"
			width="780px"
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			title="新建商品单位"
			:before-close="cancelEdit"
			class="unit-dialog"
			:visible.sync="showEdit"
			width='400px'
			height='300px'
			:close-on-click-modal="false">
			<div class="info-box">
				单位名称：
				<el-input size='mini' style="width:200px" v-model="name" placeholder="请输入单位名称 ≤4个字符"></el-input>
			</div>
			<el-button type="primary" size="mini" plain  @click="save(false)">保存</el-button>
			<el-button type="primary" size="mini" @click="save(true)">保存并新增</el-button>
		</el-dialog>
		<el-dialog
			title="选择组合内商品"
			:visible.sync="productModel"
			class="dialog-title"
			width="1260px"
			top="60px"
			@open="search"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="input-box">
						<span>商品类别：</span>
						<el-select filterable v-model="typeCategory" class="filter-input" size='mini'>
							<el-option value="0" label="全部"></el-option>
							<el-option :value="item.id" :label="item.name" v-for="item in categoryList" :key="item.id"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<span>可见状态：</span>
						<el-select v-model="visibleflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='true' label="可见"></el-option>
							<el-option :value='false' label="不可见"></el-option>
						</el-select>
					</div>
					<!-- <div class="input-box">
						<span>可售状态：</span>
						<el-select v-model="planDisabledflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='0' label="可售"></el-option>
							<el-option :value='1' label="停售"></el-option>
						</el-select>
					</div> -->
					<el-button size="small" type="primary" class="btn fx-btn" @click="searchClick">查询</el-button>
					<el-button size="small" plain class="btn fx-btn" @click="clearSearch">清空</el-button>
					<el-button type="primary" class="sbtn fx-btn" size="small" v-if="!showCheckFlag" plain @click="showCheck(true)">查看选中商品</el-button>
					<el-button type="primary" class="sbtn fx-btn" size="small" v-if="showCheckFlag" plain @click="showCheck(false)">查看全部商品</el-button>
				</div>
				<div class="filters-container">
						<div class="input-box">
						<el-input
							v-model="productKeyword"
							placeholder="请输入商品信息"
							size="mini"
							@keyup.enter.native="search">
						</el-input>
					</div>
					<div class="input-box">
						<span>启用状态：</span>
						<el-select v-model="productDisabledflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='0' label="启用"></el-option>
							<el-option :value='1' label="停用"></el-option>
						</el-select>
					</div>
				</div>
				<el-table
					class="grid-content"
					:data="productTableData"
					border
					size='mini'
					height="400"
					ref="table"
					@select="handleSelectionChange"
					@select-all="handleSelectionChange"
				>
					<el-table-column
						key='checkbox'
						type="selection"
						align="center"
						width="40">
					</el-table-column>
					<el-table-column
						key='typeCategory'
						prop="typeCategory"
						label="商品类别"
						align="center">
					</el-table-column>
					<el-table-column
						key="productname"
						prop="productname"
						label="商品名称"
						align="center">
					</el-table-column>
					<el-table-column
						key="spec"
						prop="spec"
						label="规格名称"
						align="center">
					</el-table-column>
					<el-table-column
						key="productcode"
						prop="productcode"
						label="SPU编号"
						align="center">
					</el-table-column>
					<!-- <el-table-column
						key="planDisabledflag"
						prop="planDisabledflag"
						label="可售状态"
						align="center">
						<template slot-scope='scope'>
							<div class="point-box">
								<div v-if="!scope.row.planDisabledflag" class='point' style="background-color:#60C769"></div>
								<div v-if="scope.row.planDisabledflag" class='point' style="background-color:#ED4F31"></div>
								<span>{{scope.row.planDisabledflag ? '停售' : '可售'}}</span>
							</div>
						</template>
					</el-table-column> -->
					<el-table-column
						key="visibleflag"
						prop="visibleflag"
						label="可见状态"
						align="center">
						<template slot="header">
							<div>可见状态
								<el-tooltip class="item" effect="dark" content="*可见状态是控制该商品在可以销售的情况下，买家在小程序中无法主动进行检索、下单等，但是可以通过作为附属品，赠品提单" placement="top">
									<i class="el-icon-warning-outline" style="color: var(--fx-primary-color);"></i>
								</el-tooltip>
							</div>
						</template>
						<template slot-scope='scope'>
							<div class="point-box">
								<span>{{scope.row.visibleflag ? '可见' : '不可见'}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column
						key="disabledflag"
						prop="disabledflag"
						label="启用状态"
						align="center">
						<template slot-scope='scope'>
							<div class="point-box">
								<div v-if="!scope.row.disabledflag" class='point' style="background-color:#60C769"></div>
								<div v-if="scope.row.disabledflag" class='point' style="background-color:#ED4F31"></div>
								<span>{{scope.row.disabledflag ? '已停用' : '已启用'}}</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div style="align-items: center;justify-content: space-between;height: 40px;">
					<el-pagination
						v-if="!showCheckFlag"
						style="margin: 10px; text-align: center;"
						@size-change="productSizeChange"
						@current-change="productPageChange"
						:current-page="productPagination.page"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="productPagination.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="productTotalCount">
					</el-pagination>
				</div>

				<div class="valet-foot">
					<el-button plain type="primary" size='small' @click='cancelClick'>取消</el-button>
					<el-button plain type="primary" size='small' @click='addgoodClick'>添加</el-button>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
// import ImgUpload from '@/components/goodsManagement/goodsInfo/ImgUpload.vue'
import ShowImg from '@/components/storeSetting/saleableGoods/viewModalCom/ShowImg.vue'
import AttrInfo from '@/components/goodsManagement/attributesInfo/AttrInfo.vue'
import setSpec from '@/components/storeSetting/saleableGoods/setSpec.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
import goodsIntro from '@/components/storeSetting/saleableGoods/goodsIntro.vue'
export default {
	name: 'goodsInfo',
	components: {
		// ImgUpload,
		ShowImg,
		AttrInfo,
		setSpec,
		bindShop,
		goodsIntro
	},
	data () {
		var category = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('店铺分类不能为空'))
			} else {
				callback()
			}
		}
		return {
			transportMode: 1,
			showCheckFlag: false,
			packageProductPriceType: 0,
			customizePackageProductPrice: 0,
			shopText: '',
			chooseShop: [],
			relAllShopFlag: 1,
			editDisable: true,
			shopDialog: false,
			AuthorityList: {
				'02_0003_0001_00': false,
				'02_0003_0002_00': false,
				'02_0003_0003_00': false,
				'02_0003_0004_00': false
			},
			useFlag: false,
			showEdit: false,
			name: '',
			ratio: '',
			assistUnitId: '',
			baseUnit: '',
			baseUnitId: '',
			defaultParams: {
				label: 'name',
				value: 'id'
			},
			baseList: [],
			assistList: [],
			useUnitFlag: false,
			showUnit: false,
			actualtimeinventoryflag: false,
			matchbillcenterflag: false,
			hiddenFlag: 0,
			productId: '',
			goodsid: '',
			shopid: '',
			saleState: 1,
			auditShopCount: 0,
			statusIcon: 'submit',
			isTrue: true,
			checked: false,
			bigCategoryList: [],
			smallCategoryList: [],
			thirdCategoryList: [],
			relatedStatus: false,
			ruleForm: {
				goodsName: '',
				bigCategory: '',
				smallCategory: '',
				thirdCategory: '',
				goodsExplain: '',
				code: '',
				shopSeqnum: 0,
				startRadio: false,
				visibleflag: false,
				privateRadio: false,
				mark: '-1',
				showflag: 0,
				calcNormalFreightFlag: 1,
				packageProductPriceType: 0,
				customizePackageProductPrice: 0
			},
			rules: {
				goodsName: [
					{ required: true, message: '请输入1~50个字范围内的商品名称', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入1～15个英文数字范围内的商品编号', trigger: 'blur' }
				],
				category: [
					{ required: true, validator: category, trigger: 'blur' }
				],
				startRadio: [
					{ required: true, message: '', trigger: 'blur' }
				],
				privateRadio: [
					{ required: true, message: '', trigger: 'blur' }
				],
				visibleflag: [
					{ required: true, message: '', trigger: 'blur' }
				]
			},
			productInfo: {},
			productDetails: [],
			imgInfo: [],
			videoInfo: [],
			SKUType: [],
			SKUValue: [],
			showSrc: [
				{ src: '', location: '1', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '2', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '3', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '4', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '5', id: '0', uploadError: false, imgtype: 0 },
				{ src: '', location: '6', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '7', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '8', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '9', id: '0', uploadError: false, imgtype: 1 },
				{ src: '', location: '10', id: '0', uploadError: false, imgtype: 1 }
			],
			pxcode: '',
			pxname: '',
			pxstopflag: false,
			clddock: 1,
			sourceflag: false,
			itemId: '',
			bigcategoryview: 0,
			thirdcategoryview: 0,
			saveContinueFlag: false,
			isAdd: false,
			producttype: false,
			reloadComponent: true,
			shopList: [],
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			packageflag: false,
			productAttrvalueName: '',
			skuCode: '',
			productModel: false,
			packageProducts: [],
			typeCategory: '0',
			categoryList: [],
			visibleflag: -1,
			planDisabledflag: -1,
			productDisabledflag: -1,
			productKeyword: '',
			productTableData: [],
			productPagination: {
				page: 1,
				size: 20
			},
			productTotalCount: 0,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'attrplanid'
			}),
			allCheck: [],
			costshowflag: 0,
			from: 'saleableGoods'
		}
	},
	created () {
		this.getAuthority('02_0003_0000_00')
		this.getAuthority1('02_0001_0000_00')
		this.isAdd = this.$route.query.isAdd === 'true'
		this.producttype = this.$route.query.producttype === 'true'
		this.from = this.$route.query.from
		this.shopid = sessionStorage.getItem('storeid')
		let productId = sessionStorage.getItem('productid')
		this.getInfo()
		this.getBigCategory()
		this.getCategoryList()
		if (productId) {
			this.productId = productId
			this.getGoodsInfo()
		} else {
			this.checkSmallCategory().then(res => {
				this.actualtimeinventoryflag = res.actualtimeinventoryflag === 1
				this.bigcategoryview = res.bigcategoryview
				this.matchbillcenterflag = res.matchbillcenterflag === 1
				const thirdCategoryPromise = (res.thirdcategoryview !== undefined && res.thirdcategoryview !== null)
					? Promise.resolve(this.initThirdCategoryView(res.thirdcategoryview))
					: this.checkThirdCategory()
				return thirdCategoryPromise.then(() => {
					if (this.bigcategoryview === 1) {
						return this.getSmalCategory()
					}
				})
			}).then(() => {
				if (this.ruleForm.bigCategory === '' || (this.bigcategoryview === 1 && this.ruleForm.smallCategory === '')) {
					this.isTrue = true
				} else {
					this.isTrue = false
				}
			})
		}
		this.getbaseList()
		this.getShop()
	},
	computed: {
		chooseGoods () {
			return this.tableSelectUtils.getSelectRows()
		},
		thirdCategoryEnabled () {
			return +this.bigcategoryview === 1 && +this.thirdcategoryview === 1
		}
	},
	methods: {
		refreshData () {
			this.getGoodsInfo(true)
		},
		showCheck (flag) {
			this.showCheckFlag = flag
			this.productPagination = {
				page: 1,
				size: 20
			}
			if (flag) {
				this.allCheck = this.tableSelectUtils.getSelectRows()
				this.searchTable()
			} else {
				this.search()
			}
			this.$refs.table.doLayout()
		},
		priceBlur () {
			this.customizePackageProductPrice = this.$fxUtils.toFixedSHW(this.customizePackageProductPrice, 2)
			if (this.customizePackageProductPrice > 100000000) {
				this.customizePackageProductPrice = '99999999.99'
			}
			if (this.customizePackageProductPrice < 0) {
				this.customizePackageProductPrice = '0.00'
			}
		},
		copyClick () {
			this.$confirm('您确认要复制该商品吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.copyHandle()
			}).catch(() => {

			})
		},
		copyHandle () {
			let params = {
				id: this.productId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/product/copy`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('复制成功！')
					this.productId = res.data.id
					this.getGoodsInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		addGoods () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.productTableData = []
			this.typeCategory = '0'
			this.productDisabledflag = -1
			this.productKeyword = ''
			this.visibleflag = -1
			this.planDisabledflag = -1
			this.showCheckFlag = false
			this.tableSelectUtils.clear()
			this.productModel = true
		},
		search () {
			let params = {
				typeCategory: this.typeCategory,
				disabledflag: this.productDisabledflag,
				planDisabledflag: this.planDisabledflag,
				keyword: this.productKeyword,
				page: this.productPagination.page,
				size: this.productPagination.size
			}
			if (this.visibleflag !== -1) {
				params.visibleFlag = this.visibleflag ? 1 : 0
			}
			if (this.packageProducts.length !== 0) {
				params.attrplanIds = this.packageProducts.map(item => {
					return item.attrplanid
				})
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/product/getProductAttrPlanList`,
				data: params
			}).then(res => {
				this.productTableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.productTableData, this.$refs.table)
				})
				this.productTotalCount = res.recordCount
			})
		},
		searchTable () {
			let typeCategory = this.typeCategory
			let	productDisabledflag = this.productDisabledflag
			let	planDisabledflag = this.planDisabledflag === 1
			let visibleflag = this.visibleflag
			let	productKeyword = this.productKeyword
			let arr = []
			this.allCheck.forEach(item => {
				let flag = true
				if (typeCategory !== '0') {
					let itemTypeCategory = this.bigcategoryview === 1 ? item.sbcid : item.bbcid
					if (itemTypeCategory !== typeCategory) {
						flag = flag && false
					}
				}
				if (productDisabledflag !== -1) {
					if (item.disabledflag !== productDisabledflag) {
						flag = flag && false
					}
				}
				if (planDisabledflag !== -1) {
					if (item.planDisabledflag !== planDisabledflag) {
						flag = flag && false
					}
				}
				if (visibleflag !== -1) {
					if (item.visibleflag !== visibleflag) {
						flag = flag && false
					}
				}
				if (productKeyword !== '') {
					let text = item.code + ',' + item.productname + ',' + item.spec + ',' + item.productcode
					if (text.indexOf(productKeyword) === -1) {
						flag = flag && false
					}
				}
				if (flag) {
					arr.push(item)
				}
			})
			this.productTableData = arr
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.productTableData, this.$refs.table)
			})
		},
		searchClick () {
			// this.tableSelectUtils.clear()
			if (this.showCheckFlag) {
				this.searchTable()
			} else {
				this.search()
			}
		},
		clearSearch () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.typeCategory = '0'
			this.productDisabledflag = -1
			this.productKeyword = ''
			this.visibleflag = -1
			this.planDisabledflag = -1
			if (this.showCheckFlag) {
				this.searchTable()
			} else {
				this.search()
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.productTableData, data)
			if (this.showCheckFlag) {
				this.allCheck = this.tableSelectUtils.getSelectRows()
				this.searchTable()
			}
		},
		productSizeChange (val) {
			this.productPagination.size = val
			this.productPagination.page = 1
			this.search()
		},
		productPageChange (val) {
			this.productPagination.page = val
			this.search()
		},
		cancelClick () {
			this.productModel = false
		},
		delClick (id) {
			let index = null
			this.packageProducts.forEach((item, i) => {
				if (item.attrplanid === id) {
					index = i
				}
			})
			this.packageProducts.splice(index, 1)
		},
		addgoodClick () {
			if (this.chooseGoods.length === 0) {
				this.$message.error('最少选择一个商品')
				return false
			}
			this.packageProducts = this.packageProducts.concat(this.chooseGoods)
			this.productModel = false
		},
		getCategoryList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/baseCategory/getShopCategories4Gift`
			}).then(res => {
				this.categoryList = res.data
			})
		},
		blurNum (row) {
			if (row.productcount === '' || row.productcount === null || +row.productcount === 0) {
				row.productcount = 1
			}
			row.productcount = +row.productcount
			if (row.productcount > 1000000 || row.productcount === 1000000) {
				switch (this.decimal) {
				case 0:
					row.productcount = 999999
					break
				case 1:
					row.productcount = 999999.9
					break
				case 2:
					row.productcount = 999999.99
					break
				case 3:
					row.productcount = 999999.999
					break
				case 4:
					row.productcount = 999999.9999
					break
				}
			}
		},
		checkNum (row) {
			row.productcount = row.productcount.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			row.productcount = row.productcount.replace(/^\./g, '')// 验证第一个字符是数字而不是
			row.productcount = row.productcount.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			row.productcount = row.productcount.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			switch (this.decimal) {
			case 0:
				row.productcount = row.productcount.replace(/(^[0]|[^\d])/g, '')
				break
			case 1:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
				break
			case 2:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
				break
			case 3:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3')
				break
			case 4:
				row.productcount = row.productcount.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
				break
			}
		},
		getShop () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			}).catch(() => {
			})
		},
		initShopData (data, introduction) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.shopid)
				textArr.push(item.shopname)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
			this.ruleForm.shopMsg = this.relAllShopFlag ? '全部门店' : this.shopText
			this.ruleForm.productcategory = this.getProductcategory(this.ruleForm)
			this.ruleForm.useUnitFlag = this.useUnitFlag
			this.ruleForm.packageProductPriceType = this.packageProductPriceType
			this.ruleForm.customizePackageProductPrice = this.customizePackageProductPrice
			this.ruleForm.goodsProductPlace = this.$refs.attrInfo.ruleForm.goodsProductPlace
			this.ruleForm.packList = this.$refs.attrInfo.ruleForm.packList
			this.ruleForm.qualityDate = this.$refs.attrInfo.ruleForm.qualityDate
			this.ruleForm.venderName = this.$refs.attrInfo.ruleForm.venderName
			this.ruleForm.storage = this.$refs.attrInfo.ruleForm.storage
			this.ruleForm.transportMode = this.$refs.attrInfo.transportMode
			if (!this.producttype) {
				this.ruleForm.productAttrPlanDTOS = this.$refs.setSpec.tableData
			}
			this.ruleForm.introduction = this.$refs.goodsIntro.lookList.filter(item => {
				return item.type === 1
			}).map(item => {
				return item.editor.getText()
			}).join(',')
			this.fxDataVerification.resetData(this.ruleForm)
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		bindShopClick () {
			this.shopDialog = true
		},
		getAuthority1 (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					a.forEach(item => {
						if (item === '02_0001_0001_00' && !this.isAdd) {
							this.editDisable = false
						}
						if (item === '02_0001_0002_00' && this.isAdd) {
							this.editDisable = false
						}
					})
				}
			})
		},
		ratioInput () {
			this.ratio = this.ratio.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.ratio = this.ratio.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.ratio = this.ratio.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.ratio = this.ratio.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.ratio = this.ratio.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		},
		save (flag) {
			if (this.name === '') {
				this.$message.error('请输入单位名称')
				return false
			}
			if (this.name.length > 4) {
				this.$message.error('最多输入4个字符')
				return false
			}
			let params = {
				id: 0,
				name: this.name
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/saveOrUpdateProductUnit`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
					if (flag) {
						this.name = ''
					} else {
						this.showEdit = false
						this.cancelEdit()
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancelEdit () {
			this.getbaseList()
			if (this.baseUnitId !== '') {
				this.getAssistList(this.baseUnitId)
			}
			this.showEdit = false
		},
		getbaseList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findProductUnit`
			}).then(res => {
				if (res.result) {
					this.baseList = res.data
				}
			})
		},
		assistUnitIdChange () {
			if (this.assistUnitId.length === 0) {
				this.assistUnitId = ''
				return false
			}
			this.assistUnitId = this.assistUnitId[0]
		},
		baseUnitIdChange () {
			if (this.baseUnitId.length === 0) {
				this.assistUnitId = ''
				this.baseUnitId = ''
				this.baseUnit = ''
				this.ratio = ''
				return false
			}
			this.assistUnitId = ''
			this.baseUnitId = this.baseUnitId[0]
			this.baseList.forEach(item => {
				if (item.id === this.baseUnitId) {
					this.baseUnit = item.name
				}
			})
			this.getAssistList(this.baseUnitId)
		},
		getAssistList (id) {
			let params = {
				id: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/findProductUnit`,
				data: params
			}).then(res => {
				if (res.result) {
					this.assistList = res.data
				}
			})
		},
		btnClick1 () {
			this.$router.push('/main/units')
		},
		btnClick2 () {
			this.showEdit = true
		},
		btnClick3 () {
			this.cancelEdit()
		},
		visibleChange3 (visible, refName) {
			let that = this
			if (visible) {
				const ref = this.$refs[refName]
				let popper = ref.$refs.popper
				if (popper.$el) popper = popper.$el
				if (!Array.from(popper.children).some(v => v.className === 'el-cascader-menu__list')) {
					const el = document.createElement('ul')
					el.className = 'el-cascader-menu__list'
					el.style = 'border-top: solid 1px #E4E7ED; padding:0; color: #606266;display:flex;flex-direction:row'
					el.innerHTML = `
							<li id='btn3' style="height:40px;line-height: 40px;flex:1;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
								<span><i class='el-icon-refresh'></i></span>
							</li>
							`
					popper.appendChild(el)
					const btn1 = document.getElementById('btn1')
					const btn2 = document.getElementById('btn2')
					const btn3 = document.getElementById('btn3')
					btn1.onclick = () => {
						that.btnClick1()
					}
					btn2.onclick = () => {
						that.btnClick2()
					}
					btn3.onclick = () => {
						that.btnClick3()
					}
				}
			}
		},
		visibleChange2 (visible, refName) {
			let that = this
			if (visible) {
				const ref = this.$refs[refName]
				let popper = ref.$refs.popper
				if (popper.$el) popper = popper.$el
				if (!Array.from(popper.children).some(v => v.className === 'el-cascader-menu__list')) {
					const el = document.createElement('ul')
					el.className = 'el-cascader-menu__list'
					el.style = 'border-top: solid 1px #E4E7ED; padding:0; color: #606266;display:flex;flex-direction:row'
					el.innerHTML = `
							<li id='btn2' style="height:40px;line-height: 40px;flex:1;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
								<span>新增</span>
							</li>
							<li id='btn3' style="height:40px;line-height: 40px;flex:1;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
								<span><i class='el-icon-refresh'></i></span>
							</li>
							`
					popper.appendChild(el)
					const btn1 = document.getElementById('btn1')
					const btn2 = document.getElementById('btn2')
					const btn3 = document.getElementById('btn3')
					btn1.onclick = () => {
						that.btnClick1()
					}
					btn2.onclick = () => {
						that.btnClick2()
					}
					btn3.onclick = () => {
						that.btnClick3()
					}
				}
			}
		},
		visibleChange1 (visible, refName) {
			let that = this
			if (visible) {
				const ref = this.$refs[refName]
				let popper = ref.$refs.popper
				if (popper.$el) popper = popper.$el
				if (!Array.from(popper.children).some(v => v.className === 'el-cascader-menu__list')) {
					const el = document.createElement('ul')
					el.className = 'el-cascader-menu__list'
					el.style = 'border-top: solid 1px #E4E7ED; padding:0; color: #606266;display:flex;flex-direction:row'
					el.innerHTML = `
							<li id='btn1' style="height:40px;line-height: 40px;flex:2;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
								<span>管理单位</span>
							</li>
							<li id='btn3' style="height:40px;line-height: 40px;flex:1;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
								<span><i class='el-icon-refresh'></i></span>
							</li>
							`
					popper.appendChild(el)
					const btn1 = document.getElementById('btn1')
					const btn2 = document.getElementById('btn2')
					const btn3 = document.getElementById('btn3')
					btn1.onclick = () => {
						that.btnClick1()
					}
					btn2.onclick = () => {
						that.btnClick2()
					}
					btn3.onclick = () => {
						that.btnClick3()
					}
				}
			}
		},
		visibleChange (visible, refName) {
			let that = this
			if (visible) {
				const ref = this.$refs[refName]
				let popper = ref.$refs.popper
				if (popper.$el) popper = popper.$el
				if (!Array.from(popper.children).some(v => v.className === 'el-cascader-menu__list')) {
					const el = document.createElement('ul')
					el.className = 'el-cascader-menu__list'
					el.style = 'border-top: solid 1px #E4E7ED; padding:0; color: #606266;display:flex;flex-direction:row'
					el.innerHTML = `
						<li id='btn1' style="height:40px;line-height: 40px;flex:2;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
							<span>管理单位</span>
						</li>
						<li id='btn2' style="height:40px;line-height: 40px;flex:1;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
							<span>新增</span>
						</li>
						<li id='btn3' style="height:40px;line-height: 40px;flex:1;text-align:center;color:var(--fx-primary-color);cursor: pointer;">
							<span><i class='el-icon-refresh'></i></span>
						</li>
						`
					popper.appendChild(el)
					const btn1 = document.getElementById('btn1')
					const btn2 = document.getElementById('btn2')
					const btn3 = document.getElementById('btn3')
					btn1.onclick = () => {
						that.btnClick1()
					}
					btn2.onclick = () => {
						that.btnClick2()
					}
					btn3.onclick = () => {
						that.btnClick3()
					}
				}
			}
		},
		saveContinue () {
			this.saveContinueFlag = true
			this.saveInfo()
		},
		addSku (value, id) {
			this.getGoodsInfo(true)
		},
		orderInput () {
			this.ruleForm.shopSeqnum = this.ruleForm.shopSeqnum.replace(/[^\d-]/g, '')
			if (this.ruleForm.shopSeqnum.lastIndexOf('-') > 0) {
				let numArr = this.ruleForm.shopSeqnum.split('')
				numArr.splice(this.ruleForm.shopSeqnum.lastIndexOf('-'), 1)
				this.ruleForm.shopSeqnum = numArr.join('')
			}
		},
		codeInput () {
			this.ruleForm.code = this.ruleForm.code.replace(/\\|\'|[\u4E00-\u9FA5]/g, '')
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		// 去店铺级分类页
		goClass () {
			this.$fxEventBus.$emit('setMenu', '2-6')
			this.$router.push(`/main/categoryManagement`)
		},
		goodsNameBlur () {
			this.ruleForm.goodsName = this.ruleForm.goodsName.trim()
		},
		getInfo () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findallbasicinfo`
			}).then(res => {
				if (res.result) {
					this.ruleForm.privateRadio = res.data.privateflag === 1
					this.initThirdCategoryView(res.data.thirdcategoryview)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		initThirdCategoryView (thirdcategoryview) {
			let enabled = +thirdcategoryview === 1 ? 1 : 0
			if (+this.bigcategoryview !== 1) {
				enabled = 0
			}
			this.thirdcategoryview = enabled
		},
		checkThirdCategory () {
			return this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findallbasicinfo`
			}).then(res => {
				if (res.result) {
					this.initThirdCategoryView(res.data.thirdcategoryview || 0)
				} else {
					this.thirdcategoryview = 0
				}
			}).catch(() => {
				this.thirdcategoryview = 0
			})
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bigCategoryList = res.data
				}
			})
		},
		getSmalCategory () {
			return new Promise((resolve, reject) => {
				let params = {
					pid: this.ruleForm.bigCategory
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
					data: params
				}).then(res => {
					if (res.result) {
						this.smallCategoryList = res.data
						resolve(res)
					}
				})
			})
		},
		getThirdCategory () {
			if (!this.ruleForm.smallCategory) {
				this.thirdCategoryList = []
				return
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/getThirdCategory`,
				data: { pid: this.ruleForm.smallCategory }
			}).then(res => {
				if (res.result) {
					this.thirdCategoryList = res.data || []
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		thirdCategoryVisibleChange (visible) {
			if (!visible) return
			if (!this.ruleForm.smallCategory) {
				this.$message.warning('请先选择店铺小类')
				this.$nextTick(() => {
					this.$refs.thirdCategorySelect && this.$refs.thirdCategorySelect.blur()
				})
				return
			}
			this.getThirdCategory()
		},
		bigCategoryChange (data) {
			this.ruleForm.smallCategory = ''
			this.ruleForm.thirdCategory = ''
			this.thirdCategoryList = []
			this.categoryChange(data)
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		smallCategoryChange (data) {
			this.ruleForm.thirdCategory = ''
			this.thirdCategoryList = []
			if (this.thirdCategoryEnabled && this.ruleForm.smallCategory) {
				this.getThirdCategory()
			}
			this.categoryChange(data)
		},
		categoryChange (formName) {
			if (this.ruleForm.bigCategory === '' || (this.bigcategoryview === 1 && this.ruleForm.smallCategory === '')) {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('category', (error) => {
				if (!error) {
					console.log('OK')
				} else {
					return false
				}
			})
		},
		saveInfo (type) {
			this.$refs['ruleForm'].validate((valid) => {
				if (!valid) {
					this.$message.error('请完善商品属性信息！')
					return false
				} else {
					if (this.useUnitFlag) {
						if (this.assistUnitId === '' || this.ratio === '') {
							this.$message.error('辅助单位/辅助单位换算系数不能为空')
							return false
						}
						if (this.ratio < 1) {
							this.$message.error('换算系数不能小于1')
							return false
						}
					}
					let isNew = 0
					if (type === 2) {
						isNew = 1
					}
					if (this.productId === '' || this.productId === null) {
						type = 1
					}
					this.savePost(type, isNew)
				}
			})
		},
		saveParkageInfo () {
			this.$refs['ruleForm'].validate((valid) => {
				if (!valid) {
					this.$message.error('请完善商品属性信息！')
					return false
				} else {
					if (this.productAttrvalueName === '') {
						this.$message.error('请填写规格数值！')
						return false
					}
					if (!this.packageProducts.length) {
						this.$message.error('请关联组合商品！')
						return false
					}
					this.packageProducts.forEach(item => {
						if (item.productcount === '') {
							let message = item.productname + item.spec + '数量不能为0！'
							this.$message.error(message)
							return false
						}
					})
					this.savePackagePost()
				}
			})
		},
		savePackagePost () {
			let showImgRef = this.$refs.showImgRef
			let attrInfo = this.$refs.attrInfo
			let goodsIntro = this.$refs.goodsIntro
			if (this.ruleForm.shopSeqnum !== '' && (+this.ruleForm.shopSeqnum < -9999 || +this.ruleForm.shopSeqnum > 9999)) {
				this.$message.error('商品显示顺序为－9999～9999范围内，请重新设置商品显示顺序！')
				return false
			}
			let productDetailsList = [
				{
					'name': '商品产地',
					'val': attrInfo.ruleForm.goodsProductPlace,
					'seqnum': 0
				}, {
					'name': '包装清单',
					'val': attrInfo.ruleForm.packList,
					'seqnum': 10
				},	{
					'name': '保质期',
					'val': attrInfo.ruleForm.qualityDate,
					'seqnum': 20
				},	{
					'name': '厂商名称',
					'val': attrInfo.ruleForm.venderName,
					'seqnum': 30
				},	{
					'name': '贮存条件',
					'val': attrInfo.ruleForm.storage,
					'seqnum': 40
				}
			]
			showImgRef.showSrc.forEach((item, index) => {
				item.defaultflag = index === 0 ? 1 : 0
				item.seqnum = '' + (index + 1)
			})
			let videoMap = [
				{
					id: showImgRef.videoId,
					oldurl: showImgRef.videoOldUrl,
					newurl: showImgRef.videoNewUrl,
					seqnum: 1,
					defaultflag: 1
				}
			]
			if (this.relAllShopFlag === 0 && this.chooseShop.length === 0) {
				this.$message.error('请选择适用门店')
				return false
			}
			let informationList = goodsIntro.lookList.map((item, index) => {
				return {
					seqnum: '' + (index + 1),
					id: item.id || '0',
					oldurl: item.oldUrl || '',
					newurl: item.url,
					type: item.type,
					caption: item.caption
				}
			})
			let params = {
				packageProductPriceType: this.packageProductPriceType,
				customizePackageProductPrice: this.customizePackageProductPrice,
				shopIds: this.chooseShop,
				relAllShopFlag: this.relAllShopFlag,
				id: this.productId || null,
				shopId: this.shopid,
				categoryId: this.ruleForm.bigCategory,
				scId: this.bigcategoryview === 1 ? this.ruleForm.smallCategory : 0,
				name: this.ruleForm.goodsName,
				code: this.ruleForm.code,
				seqnum: this.ruleForm.shopSeqnum,
				detailinfo: this.ruleForm.goodsExplain,
				disabledflag: this.ruleForm.startRadio,
				visibleflag: this.ruleForm.visibleflag,
				hiddenflag: this.ruleForm.privateRadio,
				showflag: this.ruleForm.showflag,
				productDetailsList: productDetailsList,
				imgMap: showImgRef.showSrc,
				videoMap: videoMap,
				productAttrvalueName: this.productAttrvalueName,
				packageflag: this.packageflag ? 1 : 0,
				producttype: this.producttype ? 1 : 0,
				productPackage: this.packageProducts,
				mark: this.ruleForm.mark === '-1' ? null : this.ruleForm.mark,
				informationList: informationList
				// productAttrPlanDTOS: setSpec.tableData
			}
			if (this.thirdCategoryEnabled) {
				params.tcId = this.ruleForm.thirdCategory ? this.ruleForm.thirdCategory : '0'
			}
			let loggerMessage = this.initPageLogger()
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			params.logMessage = {
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/saveOrUpdatePackage`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					this.productId = res.data.productId
					this.getGoodsInfo()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		translateImgArr (func) {
			return new Promise((resolve, reject) => {
				let previewArr = this.showSrc.reduce((pre, cur, index) => {
					let curSrc = this.$refs.showUpload[index][func]()
					if (curSrc) {
						pre.push(curSrc)
					}
					return pre
				}, [])
				if (previewArr.length === 0) {
					reject(previewArr)
				} else {
					resolve(previewArr)
				}
			})
		},
		savePost (type, isNew) {
			let showImgRef = this.$refs.showImgRef
			let attrInfo = this.$refs.attrInfo
			let setSpec = this.$refs.setSpec
			let goodsIntro = this.$refs.goodsIntro
			if (this.ruleForm.shopSeqnum !== '' && (+this.ruleForm.shopSeqnum < -9999 || +this.ruleForm.shopSeqnum > 9999)) {
				this.$message.error('商品显示顺序为－9999～9999范围内，请重新设置商品显示顺序！')
				return false
			}
			if (type !== 1) {
				let defaultNum = 0
				for (let i = 0; i < setSpec.tableData.length; i++) {
					let e = setSpec.tableData[i]
					if (+e.price < 0 || +e.price > 999999.99) {
						this.$message.error('【' + e.spec + '】【' + e.code + '】的销售价在0~999999.99范围内、且最大2位小数！')
						return false
					}
					if (+e.costprice < 0 || +e.costprice > 99999999.99) {
						this.$message.error('【' + e.spec + '】【' + e.code + '】的成本价在0~99999999.99范围内、且最大2位小数！')
						return false
					}
					if (e.inventory === '' && !this.matchbillcenterflag) {
						this.$message.error('【' + e.spec + '】【' + e.code + '】的库存不能为空！')
						return false
					}
					// if (+e.inventory < 0 || +e.inventory > 9999) {
					// 	this.$message.error('【' + e.spec + '】【' + e.code + '】的库存在0~9999范围内！')
					// 	return false
					// }
					if (+e.weight < 0 || +e.weight > 9999999.999) {
						this.$message.error('【' + e.spec + '】【' + e.code + '】的重量在0~9999999.999范围内！')
						return false
					}
					if (e.defaultflag) {
						defaultNum += 1
					}
					if (this.relAllShopFlag === 0 && this.chooseShop.length === 1) {
						if (e.minbuycnt === '') {
							this.$message.error('【' + e.spec + '】【' + e.code + '】的最小订货数不能为空！')
							return false
						}
						if (+e.minbuycnt < 0 || +e.minbuycnt > 9999) {
							this.$message.error('【' + e.spec + '】【' + e.code + '】的最小订货数在0~9999范围内！')
							return false
						}
						e.relProductAttrPlanShopDTOS.forEach(item => {
							if (item.shopId === this.chooseShop[0]) {
								item.maxbuyquantity = e.maxBuyQuantity || 999999
								item.maxBuyQuantityType = e.maxBuyQuantityType
								item.minbuycnt = e.minbuycnt
								item.disabledflag = e.disabledflag ? 1 : 0
								item.maxbuyquantityflag = e.maxbuyquantityflag
							}
						})
					} else {
						e.relProductAttrPlanShopDTOS.forEach(item => {
							if (item.maxbuyquantity === '') {
								item.maxbuyquantity = 999999
							}
						})
					}
				}
				if (setSpec.tableData.length !== 0 && defaultNum === 0) {
					this.$message.error('该商品没有默认规格，保存失败')
					return false
				}
			}
			let productDetailsList = [
				{
					'name': '商品产地',
					'val': attrInfo.ruleForm.goodsProductPlace,
					'seqnum': 0
				}, {
					'name': '包装清单',
					'val': attrInfo.ruleForm.packList,
					'seqnum': 10
				},	{
					'name': '保质期',
					'val': attrInfo.ruleForm.qualityDate,
					'seqnum': 20
				},	{
					'name': '厂商名称',
					'val': attrInfo.ruleForm.venderName,
					'seqnum': 30
				},	{
					'name': '贮存条件',
					'val': attrInfo.ruleForm.storage,
					'seqnum': 40
				}
			]
			showImgRef.showSrc.forEach((item, index) => {
				item.defaultflag = index === 0 ? 1 : 0
				item.seqnum = '' + (index + 1)
			})
			let videoMap = [
				{
					id: showImgRef.videoId,
					oldurl: showImgRef.videoOldUrl,
					newurl: showImgRef.videoNewUrl,
					seqnum: 1,
					defaultflag: 1
				}
			]
			if (this.relAllShopFlag === 0 && this.chooseShop.length === 0) {
				this.$message.error('请选择适用门店')
				return false
			}
			let informationList = goodsIntro.lookList.map((item, index) => {
				return {
					seqnum: '' + (index + 1),
					id: item.id || '0',
					oldurl: item.oldUrl || '',
					newurl: item.url,
					type: item.type,
					caption: item.caption
				}
			})
			let params = {
				transportMode: attrInfo.transportMode,
				shopIds: this.chooseShop,
				relAllShopFlag: this.relAllShopFlag,
				id: this.productId || null,
				shopId: this.shopid,
				useUnitFlag: this.useUnitFlag ? 1 : 0,
				relProductUnit: {
					baseUnitId: this.baseUnitId,
					assistUnitId: this.assistUnitId,
					ratio: this.ratio
				},
				categoryId: this.ruleForm.bigCategory,
				scId: this.bigcategoryview === 1 ? this.ruleForm.smallCategory : 0,
				name: this.ruleForm.goodsName,
				code: this.ruleForm.code,
				seqnum: this.ruleForm.shopSeqnum,
				detailinfo: this.ruleForm.goodsExplain,
				disabledflag: this.ruleForm.startRadio,
				showflag: this.ruleForm.showflag,
				visibleflag: this.ruleForm.visibleflag,
				hiddenflag: this.ruleForm.privateRadio,
				productDetailsList: productDetailsList,
				imgMap: showImgRef.showSrc,
				videoMap: videoMap,
				mark: this.ruleForm.mark === '-1' ? null : this.ruleForm.mark,
				calcNormalFreightFlag: this.ruleForm.calcNormalFreightFlag,
				informationList: informationList
				// productAttrPlanDTOS: setSpec.tableData
			}
			if (this.thirdCategoryEnabled) {
				params.tcId = this.ruleForm.thirdCategory ? this.ruleForm.thirdCategory : '0'
			}
			if (type !== 1) {
				params.productAttrPlanDTOS = this.handleSpecData(setSpec.tableData)
			}
			let loggerMessage = this.initGoodLogger()
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			params.logMessage = {
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/saveOrUpdate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					showImgRef.showSrc.forEach(item => {
						if (!item.newurl) {
							item.id = '0'
						}
					})
					if (type !== 1) {
						if (!this.saveContinueFlag) {
							this.productId = res.data.productId
							this.getGoodsInfo()
						} else {
							if (this.saveContinueFlag) {
								window.sessionStorage.removeItem('productid')
								this.resetForm()
								this.reloadComponent = false
								this.$nextTick(() => {
									this.reloadComponent = true
								})
							}
						}
					} else {
						if (!this.saveContinueFlag) {
							window.sessionStorage.setItem('productid', res.data.productId)
							this.productId = res.data.productId
							this.getGoodsInfo()
							if (isNew === 1) {
								setSpec.addSkuModal = true
							}
						} else {
							this.resetForm()
							this.reloadComponent = false
							this.$nextTick(() => {
								this.reloadComponent = true
							})
							// this.reload()
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSpecData (data) {
			data = this.$fxUtils.deepClone(data)
			data.forEach((e, index) => {
				e.price = e.price || -1
				e.seqnum = index + 1
				if (e.maxBuyQuantity === '') {
					e.maxBuyQuantity = 999999
				}
			})
			return data
		},
		cateidToText () {
			let bc = this.bigCategoryList
			let bcName = ''
			let sc = this.smallCategoryList
			let scName = ''
			let tc = this.thirdCategoryList
			let tcName = ''
			bc.forEach(item => {
				if (item.bc_id === this.ruleForm.bigCategory) {
					bcName = item.bc_name
				}
			})
			sc.forEach(item => {
				if (item.id === this.ruleForm.smallCategory) {
					scName = item.name
				}
			})
			tc.forEach(item => {
				if (item.id === this.ruleForm.thirdCategory) {
					tcName = item.name
				}
			})
			let text = bcName + (this.bigcategoryview === 1 ? scName : '') + (this.thirdCategoryEnabled && this.ruleForm.thirdCategory ? tcName : '')
			return text
		},
		initPageLogger () {
			let message = ''
			message = '商品名称：' + this.ruleForm.goodsName + ',店铺分类:' + this.cateidToText() + ',启用状态:' + (this.ruleForm.startRadio ? '禁用' : '启用') + ',私密状态:' + (this.ruleForm.privateRadio ? '私密' : '公开') + ',可见状态:' + (this.ruleForm.visibleflag ? '可见' : '不可见') + ',店内显示顺序:' + this.ruleForm.shopSeqnum + ',参与整单运费计算:' + (this.ruleForm.calcNormalFreightFlag === 1 ? '参与' : '不参与') + ',未登录时是否显示:' + (this.ruleForm.showflag === 1 ? '显示' : '不显示') + ',适用门店:' + (this.relAllShopFlag === 1 ? '全部门店' : this.shopText) + ',运输方式:' + (this.$refs.attrInfo.transportMode === 1 ? '常温运输' : '冷链运输') + ',商品产地:' + this.$refs.attrInfo.ruleForm.goodsProductPlace + ',包装清单:' + this.$refs.attrInfo.ruleForm.packList + ',保质期:' + this.$refs.attrInfo.ruleForm.qualityDate + ',厂商名称:' + this.$refs.attrInfo.ruleForm.venderName + ',贮存条件:' + this.$refs.attrInfo.ruleForm.storage + ',组合品：'
			let list = this.packageProducts
			list.forEach(item => {
				message = message + '[商品名称：' + item.productname + ',商品数量：' + item.productcount + ']'
			})
			return message
		},
		initGoodLogger () {
			let message = ''
			message = '商品名称：' + this.ruleForm.goodsName + ',店铺分类:' + this.cateidToText() + ',启用状态:' + (this.ruleForm.startRadio ? '禁用' : '启用') + ',私密状态:' + (this.ruleForm.privateRadio ? '私密' : '公开') + ',可见状态:' + (this.ruleForm.visibleflag ? '可见' : '不可见') + ',店内显示顺序:' + this.ruleForm.shopSeqnum + ',参与整单运费计算:' + (this.ruleForm.calcNormalFreightFlag === 1 ? '参与' : '不参与') + ',未登录时是否显示:' + (this.ruleForm.showflag === 1 ? '显示' : '不显示') + ',适用门店:' + (this.relAllShopFlag === 1 ? '全部门店' : this.shopText) + ',运输方式:' + (this.$refs.attrInfo.transportMode === 1 ? '常温运输' : '冷链运输') + ',商品产地:' + this.$refs.attrInfo.ruleForm.goodsProductPlace + ',包装清单:' + this.$refs.attrInfo.ruleForm.packList + ',保质期:' + this.$refs.attrInfo.ruleForm.qualityDate + ',厂商名称:' + this.$refs.attrInfo.ruleForm.venderName + ',贮存条件:' + this.$refs.attrInfo.ruleForm.storage + ',规格：'
			let shopIds = this.chooseShop
			let list = this.$refs.setSpec.tableData
			let msgArr = []
			list.forEach(item => {
				let arr = []
				item.relProductAttrPlanShopDTOS.forEach(relItem => {
					const logMaxQuantity = relItem.maxBuyQuantityType === 0 ? '不限' : relItem.maxbuyquantity
					if ((shopIds.indexOf(relItem.shopId) !== -1) && this.relAllShopFlag === 0) {
						let row = '店铺名称：' + relItem.shopname + ',最大订货量：' + logMaxQuantity + ',最小起订量：' + relItem.minbuycnt + ',可售状态：' + (relItem.disabledflag === 0 ? '可售' : '停售')
						arr.push(row)
					}
					if (this.relAllShopFlag === 1) {
						let row = '店铺名称：' + relItem.shopname + ',最大订货量：' + logMaxQuantity + ',最小起订量：' + relItem.minbuycnt + ',可售状态：' + (relItem.disabledflag === 0 ? '可售' : '停售')
						arr.push(row)
					}
				})
				// console.log(arr)
				const logPrice = item.price < 0 || item.price === '' ? '空' : item.price
				let msgRow = '[规格数值:' + item.spec + ',销售价:' + logPrice + ',重量:' + item.weight + ',展示顺序:' + (item.seqnum || '') + arr.join(',') + ']'
				msgArr.push(msgRow)
			})
			message = message + msgArr.join(',')
			return message
		},
		resetForm () {
			this.productId = ''
			this.ruleForm = {
				goodsName: '',
				bigCategory: '',
				smallCategory: '',
				thirdCategory: '',
				goodsExplain: '',
				code: '',
				shopSeqnum: 0,
				startRadio: false,
				visibleflag: false,
				privateRadio: false,
				calcNormalFreightFlag: 1
			}
			this.ratio = ''
			this.assistUnitId = ''
			this.baseUnitId = ''
			this.useUnitFlag = false
			this.useFlag = false
			this.$refs.attrInfo.ruleForm = {
				goodsProductPlace: '',
				packList: '',
				qualityDate: '',
				venderName: '',
				storage: ''
			}
			this.SKUValue = []
			this.SKUType = []
			this.imgInfo = []
			this.videoInfo = []
			this.thirdCategoryList = []
			this.productInfo = {}
			this.productDetails = []
			// this.$refs.showImgRef.showSrc = []
			this.saveContinueFlag = false
		},
		// reload () {
		// 	this.isRouterAlive = false
		// 	this.$nextTick(() => {
		// 		this.isRouterAlive = true
		// 	})
		// },
		uploadAsync: async function (uploadFileArr) {
			for (let i = 0; i < uploadFileArr.length; i++) {
				await this.$refs.showUpload[uploadFileArr[i] - 1].uploadImgHandler()
			}
			this.$message.success('保存成功！')
		},
		getGoodsInfo (flag) {
			let params = {
				id: this.productId,
				shopid: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/product/detail`,
				data: params
			}).then(res => {
				if (res.result) {
					if (flag) {
						res.data.SKUValue.forEach(e => {
							e.checked = false
							if (e.maxBuyQuantityType === 0) {
								e.maxBuyQuantity = ''
							}
							e.relProductAttrPlanShopDTOS.forEach(item => {
								item.searchShow = true
							})
							e.price = e.price < 0 ? '' : this.$fxUtils.toFixedSHW(e.price, 2)
							e.costprice = this.$fxUtils.toFixedSHW(e.costprice, 2)
						})
						res.data.SKUValue.forEach(e => {
							if (e.price === 0) {
								e.price = '0.00'
							}
							if (e.weight === 0) {
								e.weight = '0.000'
							}
						})
						this.SKUType = res.data.SKUType
						this.SKUValue = res.data.SKUValue
						this.$refs.setSpec.applySkuValue(this.SKUValue)
					} else {
						res.data.SKUValue.forEach(e => {
							e.checked = false
							if (e.maxBuyQuantityType === 0) {
								e.maxBuyQuantity = ''
							}
							e.relProductAttrPlanShopDTOS.forEach(item => {
								item.searchShow = true
							})
							e.price = e.price < 0 ? '' : this.$fxUtils.toFixedSHW(e.price, 2)
							e.costprice = this.$fxUtils.toFixedSHW(e.costprice, 2)
						})
						res.data.img.forEach(item => {
							if (item.commpressflag) {
								if (item.url) {
									item.url = this.$fxUtils.changeImgSrc(item.url, 'big')
								}
							}
						})
						this.$refs.attrInfo.transportMode = res.data.product.transportMode
						this.packageProductPriceType = res.data.product.packageProductPriceType
						this.customizePackageProductPrice = res.data.product.customizePackageProductPrice
						this.relAllShopFlag = res.data.product.relAllShopFlag
						this.ratio = res.data.relProductUnit.ratio
						this.assistUnitId = res.data.relProductUnit.assistUnitId
						this.baseUnitId = res.data.relProductUnit.baseUnitId
						this.baseUnit = res.data.relProductUnit.baseUnitName
						this.useFlag = res.data.relProductUnit.useFlag === 1
						this.useUnitFlag = res.data.product.useUnitFlag === 1
						this.getAssistList(this.baseUnitId)
						this.productInfo = res.data.product
						this.ruleForm.goodsName = res.data.product.pname
						this.ruleForm.code = res.data.product.pcode
						this.ruleForm.bigCategory = res.data.product.bcid
						this.ruleForm.smallCategory = res.data.product.bccid
						let thirdCategoryValue = res.data.product.tcId
						this.ruleForm.thirdCategory = thirdCategoryValue && thirdCategoryValue !== '0' && thirdCategoryValue !== 0 ? thirdCategoryValue : ''
						this.ruleForm.calcNormalFreightFlag = res.data.product.calcNormalFreightFlag
						this.producttype = res.data.product.producttype === 1
						this.packageflag = Boolean(res.data.product.packageflag)
						if (this.ruleForm.smallCategory) {
							this.isTrue = false
						}
						this.ruleForm.startRadio = res.data.product.disabledflag
						this.ruleForm.privateRadio = res.data.product.hiddenflag
						this.ruleForm.visibleflag = res.data.product.visibleflag
						this.ruleForm.showflag = res.data.product.showflag
						this.ruleForm.shopSeqnum = res.data.product.seqnum
						this.ruleForm.goodsExplain = res.data.product.detailinfo
						this.ruleForm.mark = res.data.product.mark ? res.data.product.mark : '-1'
						this.productDetails = res.data.productDetails
						this.imgInfo = res.data.img
						this.videoInfo = res.data.video
						this.SKUType = res.data.SKUType
						this.packageProducts = res.data.productPackage
						res.data.SKUValue.forEach(e => {
							if (e.price === 0) {
								e.price = '0.00'
							}
							if (e.weight === 0) {
								e.weight = '0.000'
							}
						})
						this.SKUValue = res.data.SKUValue
						this.$refs.setSpec.applySkuValue(this.SKUValue)
						this.skuCode = this.SKUValue.length !== 0 ? this.SKUValue[0].code : ''
						this.productAttrvalueName = this.SKUValue.length !== 0 ? this.SKUValue[0].spec : ''
						let shops = res.data.shops
						let information = res.data.information
						if (this.$refs.goodsIntro.addList.length === 0) {
							this.$refs.goodsIntro.addList = information
							// this.$refs.goodsIntro.lookList = this.$fxUtils.deepClone(information)
							this.$refs.goodsIntro.paintList()
							this.$refs.goodsIntro.checkNum()
						}
						this.checkSmallCategory().then(res => {
							this.bigcategoryview = res.bigcategoryview
							this.matchbillcenterflag = res.matchbillcenterflag === 1
							this.actualtimeinventoryflag = res.actualtimeinventoryflag === 1
							this.costshowflag = res.costshowflag
							const thirdCategoryPromise = (res.thirdcategoryview !== undefined && res.thirdcategoryview !== null)
								? Promise.resolve(this.initThirdCategoryView(res.thirdcategoryview))
								: this.checkThirdCategory()
							return thirdCategoryPromise.then(() => {
								const loadShopData = () => {
									if (this.thirdCategoryEnabled && this.ruleForm.smallCategory) {
										this.getThirdCategory()
									}
									this.initShopData(shops)
								}
								if (this.bigcategoryview === 1) {
									return this.getSmalCategory().then(() => {
										loadShopData()
									})
								}
								loadShopData()
							})
						}).then(() => {
							if (this.ruleForm.bigCategory === '' || (this.bigcategoryview === 1 && this.ruleForm.smallCategory === '')) {
								this.isTrue = true
							} else {
								this.isTrue = false
							}
						})
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getImgInfo () {
			let params = {
				id: sessionStorage.getItem('goodsid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getGoodsImgInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.showSrc.forEach(item => {
						res.data.forEach(dataItem => {
							if (item.location === '' + dataItem.imgsort) {
								item.src = dataItem.imgurl
								item.id = dataItem.id
							}
						})
					})
				}
			})
		},
		cancel () {
			this.$router.push(`/main/${this.from}`)
		},
		verify () {
			let params = {
				ids: sessionStorage.getItem('goodsid')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/saveOrUpdateProductBase`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('申请审核成功！')
					this.statusIcon = 'pending'
				} else {
					this.$message.error('申请审核失败！')
				}
			})
		},
		saleStateChange (value) {
			if (sessionStorage.getItem('goodsid')) {
				if (value === 0 && this.statusIcon === 'pass' && this.relatedStatus) {
					this.$message({
						message: '修改后商城中商品变为不可售状态！',
						type: 'warning',
						duration: 3000
					})
				}
			}
		},
		relatedStatusPost () {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				shopName: '',
				comFlag: 0,
				size: 20,
				page: 1,
				order: 1,
				orderKey: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getShopInfoOfProduct`,
				data: params
			}).then(res => {
				if (res.result) {
					this.relatedStatus = res.data.recordCount > 0
				}
			})
		},
		refresh () {
			let params = {
				itemId: this.itemId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/dockcld/refreshCldGoodsStopFlag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.pxstopflag = res.data.mdStopFLag
					this.$message.success('刷新成功！')
				} else {
					this.$message.error(res.msg)
				}
			}).catch((e) => {
				this.$message.error(e.msg)
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			ruleForm.productcategory = this.getProductcategory(ruleForm)
			ruleForm.packageProductPriceType = this.packageProductPriceType
			ruleForm.customizePackageProductPrice = this.customizePackageProductPrice
			ruleForm.shopMsg = this.relAllShopFlag ? '全部门店' : this.shopText
			ruleForm.useUnitFlag = this.useUnitFlag
			ruleForm.goodsProductPlace = this.$refs.attrInfo.ruleForm.goodsProductPlace
			ruleForm.packList = this.$refs.attrInfo.ruleForm.packList
			ruleForm.qualityDate = this.$refs.attrInfo.ruleForm.qualityDate
			ruleForm.venderName = this.$refs.attrInfo.ruleForm.venderName
			ruleForm.storage = this.$refs.attrInfo.ruleForm.storage
			ruleForm.transportMode = this.$refs.attrInfo.transportMode
			ruleForm.introduction = this.$refs.goodsIntro.lookList.filter(item => {
				return item.type === 1
			}).map(item => {
				return item.editor.getText()
			}).join(',')
			if (!this.producttype) {
				ruleForm.productAttrPlanDTOS = this.$refs.setSpec.tableData
			}
			return {
				pre: originData,
				cur: ruleForm,
				name: ruleForm.goodsName
			}
		},
		getProductcategory ({ bigCategory, smallCategory, thirdCategory }) {
			if (this.bigcategoryview === 1) {
				if (!bigCategory || !smallCategory) {
					return ''
				}
				const _bigCategory = (this.bigCategoryList.find(item => {
					return item.bc_id === bigCategory
				}) || {}).bc_name
				const _smallCategory = (this.smallCategoryList.find(item => {
					return item.id === smallCategory
				}) || {}).name
				let categoryText = `${_bigCategory}-${_smallCategory}`
				if (this.thirdCategoryEnabled && thirdCategory) {
					const _thirdCategory = (this.thirdCategoryList.find(item => {
						return item.id === thirdCategory
					}) || {}).name
					if (_thirdCategory) {
						categoryText += `-${_thirdCategory}`
					}
				}
				return categoryText
			} else {
				const _bigCategory = (this.bigCategoryList.find(item => {
					return item.bc_id === bigCategory
				}) || {}).bc_name
				return `${_bigCategory}`
			}
		}
	}
}
</script>
<style lang="stylus">
	.category-box .el-form-item__content {
		width: auto
		min-width: 0
		flex: 1
	}
	.category-select-wrap {
		display: flex
		flex-wrap: nowrap
		align-items: center
		.category-select {
			width: 160px
			flex-shrink: 0
			&:not(:last-child) {
				margin-right: 10px
			}
		}
		.el-button {
			flex-shrink: 0
			white-space: nowrap
			margin-left: 10px
		}
	}
	.textarea-box .el-form-item__content {
		width: 300px
	}
	.state-box .el-form-item__content {
		width: 220px
	}
	.freight-box .el-form-item__content {
		width: 220px
	}
	.freight-box .el-form-item__label {
		width: 170px!important
	}
</style>
<style lang="stylus" scoped>
.title-box {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.spec-title {
		width: 14px;
		height: 14px;
		cursor: pointer;
		margin: -1px 0 0 4px!important;
	}
.goods-info-body {
	display flex
	flex: 1
	height: calc(100% - 75px)
	flex-direction column
	/deep/.el-form-item.is-success .el-input__inner {
		border-color: #DCDFE6
	}
	.title1{
		text-align: right;
		vertical-align: middle;
		float: left;
		min-width: 90px;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		box-sizing: border-box;
	}
	.unit-box{
		display: flex;
		height: 60px;
		align-items :center;
		padding-left: 20px;
		flex-direction :row;
	}
	.goods-info-box {
		overflow-y auto
		display flex
		flex 1
		flex-direction column
		.basis-info-body {
			padding-top: 20px
			box-sizing border-box
			border-bottom: 1px solid #dce2fd
			text-align left
			p {
				height 20px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				position relative
				color: #9E9C9D
				font-size 14px
				span {
					&:first-child {
						font-size 16px
						color: #2c3e50
					}
					&:nth-of-type(2) {
						margin: 0 30px;
					}
				}
				.el-button {
					position absolute
					margin-left 30px;
					top: -4px;
				}
			}
			.form-box {
				display flex
				flex-direction: column
				padding-top 10px
				.info-box {
					display: flex
					width: 100%
					min-width: 1000px
					margin-bottom: 15px;
					.category-box {
						flex: 1
						min-width: 0
					}
					.short-input {
						width: 200px
						&:nth-of-type(1) {
							margin-right 20px
						}
					}
				}
				.status {
					flex: 7
					.status-icon {
						display inline-block
						width: 108px
						height: 56px
					}
					.pass {
						background-image: url('~images/icon/pass.png')
					}
					.pending {
						background-image: url('~images/icon/pending.png')
					}
					.reject {
						background-image: url('~images/icon/reject.png')
					}
					.submit {
						background-image: url('~images/icon/submit.png')
					}
				}
			}
			.package-info {
				display: flex;
				flex-flow: row;
				align-items: center;
				justify-content: space-between;
				// padding: 20px 0;
				.left {
					display: flex;
					flex-flow: row;
					align-items: center;
					justify-content: space-between;
					padding: 20px 0;
					.info-box {
						min-width: 250px;
					}
				}
				.right {
					display: flex;
					align-items: center;
					padding-right: 50px;
					margin-bottom: 20px;
				}
			}
		}
		.show-img-body {
			// padding: 20px 0
			// min-height: 440px
			box-sizing border-box
			border-bottom: 1px solid #dce2fd
			text-align left
			display flex
			padding-bottom: 10px;
			.img-box {
				flex: 1
				p {
					height 20px
					font-size 16px
					line-height 20px
					border-left 4px solid var(--fx-primary-color)
					padding-left 8px
				}
				.img-container {
					max-width: 600px
				}
				.img-tips {
					padding: 20px 0 20px 12px
					color: #a7a7a7
				}
			}
		}
		.goods-status-box {
			text-align left
			p {
				height 20px
				font-size 16px
				line-height 20px
				border-left 4px solid var(--fx-primary-color)
				padding-left 8px
				margin 20px 0
			}
			span {
				color: red
				margin-right 6px
			}
		}
	}
	.btn-box {
		padding: 20px 0
		text-align center
		cursor: default
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
	.filters-container {
		display: flex;
		flex-direction: row;
		height: 50px;
		align-items: center;
		margin-bottom:10px;
		.input-box{
			margin-right:10px
		}
		.el-input {
			width: 200px
		}
	}
}
.info-box{
	display :flex;
	margin-bottom :20px;
	flex-direction :row;
	align-items :center
}
</style>
<style lang="stylus">
.unit-dialog{
	.el-dialog__header{
		text-align :left
	}
	.dialog-title {
		text-align: left
	}
	.el-dialog__body{
		padding:10px;
	}
}
.el-dialog__header{
	text-align :left
}
</style>
